function rankAgentUnitPositions({ agentSide, gameState, rules, }) {
    const agentUnits = gameState.units.filter((u) => u.side === agentSide);
    const rankedUnitPositions = [];
    agentUnits.forEach((unit) => {
        rankedUnitPositions.push({
            ...unit.position,
            rank: rules.getNumOfAdjacentFriendlyUnits(unit, gameState),
        });
    });
    return rankedUnitPositions;
}
export default rankAgentUnitPositions;
